import { PointsArray, PointsObject } from '@/domain/pointsApi/types'
import { useCallback } from 'react'
import { getPointsEntryByAddress } from '@/domain/pointsApi/utils'
import { Address } from 'viem'

export type GroupedPoints = Record<string, PointsArray>
const EMPTY_POINTS: PointsArray = []

interface GetByAddressParams {
  type: string
  action: string
  address: Address
}

export interface UsePointsDataResult {
  data: PointsArray | undefined
  isLoading: boolean
  error: Error | null
  getByAddress: (params: GetByAddressParams) => PointsObject | undefined
  getByConversionId: (id: string) => PointsObject | undefined
}

export function usePointsData(): UsePointsDataResult {
  const data = EMPTY_POINTS

  const getByAddress = useCallback(
    (params: GetByAddressParams): PointsObject | undefined => {
      if (!data) {
        return undefined
      }
      return getPointsEntryByAddress(data, params)
    },
    [data],
  )

  const getByConversionId = useCallback(
    (id: string): PointsObject | undefined => {
      if (!data) {
        return undefined
      }
      return data.find((point) => point.id === id)
    },
    [data],
  )

  return {
    isLoading: false,
    error: null,
    data,
    getByAddress,
    getByConversionId,
  }
}
